import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatCard, MatCardContent} from '@angular/material/card';
import {ReactiveFormsModule} from '@angular/forms';
import {PatronSelectors} from '@store/patron/patron.selectors';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {ViewportSelectors} from '@aviary/store/viewport/viewport.selectors';
import {NgTemplateOutlet} from '@angular/common';
import {DetailFieldDefaultsDirective} from '@aviary/components/detail-field/detail-field-defaults/detail-field-defaults.directive';
import {DetailFieldComponent} from '@aviary/components/detail-field/detail-field.component';
import {FormatPipe} from '@aviary/pipes/format.pipe';
import {HiddenUntilLoadedDirective} from '@aviary/directives/hidden-until-loaded.directive';
import {ArrowTextButtonComponent} from '@lib/components/arrow-text-button/arrow-text-button.component';

@Component({
  selector: 'px-family-accounts',
  templateUrl: './related-accounts.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCard, MatCardContent, ReactiveFormsModule, SelectPipe, NgTemplateOutlet, DetailFieldDefaultsDirective, DetailFieldComponent, FormatPipe, HiddenUntilLoadedDirective, ArrowTextButtonComponent]
})
export class RelatedAccountsComponent {
  public readonly relationshipsSelectors = PatronSelectors.PatronRelationships;
  public readonly statelessSelectors = PatronSelectors.RelatedPatronStateless;
  public readonly viewportSelectors = ViewportSelectors;
}
